module.exports = __webpack_public_path__ + "img/img1.50b6e8ec.jpg";